<template>
  <div :class="$style.catalogueProvidersSkeletonWrapper">
    <div v-for="item in itemsCount" :key="item" :class="$style.providersSkeletonDoubleItem">
      <Skeleton v-for="index in 2" :key="index" :class="$style.providerItemSkeleton" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import Skeleton from '~/components/lib/skeleton/skeleton.vue';

const props = defineProps({
  maxSlidesPerView: {
    type: Number,
    default: undefined,
  },
});

const itemsCount = computed(() => {
  return props.maxSlidesPerView ? props.maxSlidesPerView : 10;
});
</script>

<style lang="scss" module>
.catalogueProvidersSkeletonWrapper {
  display: flex;
  gap: 16px;

  @media (max-width: 580px) {
    .providersSkeletonDoubleItem:nth-child(n + 4) {
      display: none;
    }
  }
  @media (max-width: 768px) and (min-width: 580px) {
    .providersSkeletonDoubleItem:nth-child(n + 5) {
      display: none;
    }
  }
  @media (max-width: 1632px) and (min-width: 768px) {
    gap: 24px;
    .providersSkeletonDoubleItem:nth-child(n + 7) {
      display: none;
    }
  }
  @media (max-width: 2560px) and (min-width: 1632px) {
    gap: 24px;
    .providersSkeletonDoubleItem:nth-child(n + 9) {
      display: none;
    }
  }

  .providersSkeletonDoubleItem {
    flex-grow: 1;
    &:last-child {
      margin: 0;
    }
  }
}
.providerItemSkeleton {
  position: relative;
  isolation: isolate;
  height: 48px;
  width: 100%;
  position: relative;
  margin: 0 0 16px;
  &:last-of-type {
    margin: 0;
  }
}
</style>
